import styled from 'styled-components';
export const UINotificationBadgeWrapper = styled.div.withConfig({
  displayName: "Notificationstyle__UINotificationBadgeWrapper"
})(["position:", ";top:", ";left:", ";cursor:", ";"], ({
  absolute
}) => absolute ? 'absolute' : 'relative', ({
  top
}) => top !== undefined ? `${top}px` : 'unset', ({
  left
}) => left !== undefined ? `${left}px` : '50%', ({
  pointer
}) => pointer ? 'pointer' : 'unset');
export const CountBadge = styled.span.withConfig({
  displayName: "Notificationstyle__CountBadge"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    width: theme.space['600'],
    height: theme.space['600'],
    borderRadius: theme.borderRadius['full'],
    backgroundColor: theme.color['fill-accent-magenta-default'],
    color: theme.color['text-core-on-fill-default'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `2px solid ${theme.color['border-core-on-fill-default']}`,
    fontSize: '10px',
    fontWeight: 'bold'
  };
});
export const ParticipantNotificationBadgeWrapper = styled.div.withConfig({
  displayName: "Notificationstyle__ParticipantNotificationBadgeWrapper"
})(["cursor:pointer;position:absolute;left:25px;top:-6px;z-index:1;"]);
export const NotificationChildrenWrapper = styled.div.withConfig({
  displayName: "Notificationstyle__NotificationChildrenWrapper"
})(["height:inherit;[data-test-id]{height:inherit;}"]);